import { Route, Routes, useLocation } from "react-router-dom";

import { PrivateRoute } from "./PrivateRoute";

import { Login } from "../Pages/login/Login";

import Home from "../Pages/Home";
import Dashboard from "../Pages/Dashboard";
import { Welcome } from "../Pages/Welcome";
import { AdminDashboard } from "../Pages/AdminDashboard";

export const AllRoutes = () => {
  const location = useLocation();
  const showNavbar =
    location.pathname !== "/login" && location.pathname !== "/welcome";

  return (
    <>
      {/* {showNavbar && <ManoshalaNavbar />} */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Home />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Route>
      </Routes>
    </>
  );
};
